import { render, staticRenderFns } from "./TodayDashboard.vue?vue&type=template&id=0f38d4f2&"
import script from "./TodayDashboard.vue?vue&type=script&lang=ts&"
export * from "./TodayDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports